var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_154_400)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.584 0.934369C15.3667 0.716475 15.0714 0.594022 14.7636 0.594022C14.4559 0.594022 14.1607 0.716475 13.9433 0.934369L8.25312 6.61292L2.56294 0.922732C2.34554 0.704838 2.05039 0.582386 1.74258 0.582386C1.43478 0.582386 1.13962 0.704838 0.922219 0.922732C0.468401 1.37655 0.468401 2.10964 0.922219 2.56346L6.6124 8.25364L0.922219 13.9438C0.468401 14.3976 0.468401 15.1308 0.922219 15.5846C1.37604 16.0384 2.10912 16.0384 2.56294 15.5846L8.25312 9.89437L13.9433 15.5846C14.3971 16.0384 15.1302 16.0384 15.584 15.5846C16.0378 15.1308 16.0378 14.3976 15.584 13.9438L9.89385 8.25364L15.584 2.56346C16.0262 2.12128 16.0262 1.37655 15.584 0.934369Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_154_400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6dac17fac0dd655f52ee52ad9395ade2.svg";
export { ForwardRef as ReactComponent };